import { useOrgConfigStateValue } from './business/useOrgConfig';
import { useCountryCodeValue } from './business/system/useCountryCode';
import chatttSDK from 'services/chattt';
import { useCallback, useEffect, useMemo } from 'react';
import { gt, isUndefined, upperCase } from 'lodash-es';
import posthog from '@leyan/lytics';

const systemCountryCode = chatttSDK?.app?.getLocaleCountryCode();

export const useXiapibuyEnable = (region: string) => {
  const { xiapibuyEnable } = useOrgConfigStateValue();
  const countryCodeValue = useCountryCodeValue();
  const countryCode = countryCodeValue || systemCountryCode;
  const isCountryCodeEqual = useMemo(() => {
    if (!countryCode) return true;
    return gt(countryCode?.indexOf(upperCase(region)), -1);
  }, [region, countryCode]);

  useEffect(() => {
    if (countryCode) {
      posthog.capture('$xiapibuyenalbe', {
        countryCodeValue,
        systemCountryCode,
        region,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  if (isUndefined(xiapibuyEnable)) return !isCountryCodeEqual;

  return xiapibuyEnable;
};

export const useGetXiapibuyEnable = () => {
  const { xiapibuyEnable } = useOrgConfigStateValue();
  const countryCodeValue = useCountryCodeValue();
  const countryCode = countryCodeValue || systemCountryCode;

  return useCallback(
    (region: string) => {
      const isCountryCodeEqual = !countryCode || gt(countryCode?.indexOf(upperCase(region)), -1);

      if (isUndefined(xiapibuyEnable)) return !isCountryCodeEqual;

      return xiapibuyEnable;
    },
    [countryCode, xiapibuyEnable],
  );
};
